/**
 * Tiny sessionStorage cache for the catalog so returning to a grid feels instant.
 *
 *   const cached = catalogCache.get();
 *   if (cached) setProducts(cached);                 // paint immediately
 *   API.get('/catalog?summary=1').then(r => {        // then refresh in background
 *     setProducts(r.data);
 *     catalogCache.set(r.data);
 *   });
 */
const KEY = 'pk_catalog_v1';
const TTL_MS = 5 * 60 * 1000; // 5 minutes

export const catalogCache = {
  get() {
    try {
      const raw = sessionStorage.getItem(KEY);
      if (!raw) return null;
      const { ts, data } = JSON.parse(raw);
      if (!ts || !data) return null;
      if (Date.now() - ts > TTL_MS) return null;
      return data;
    } catch {
      return null;
    }
  },
  set(data) {
    try {
      sessionStorage.setItem(KEY, JSON.stringify({ ts: Date.now(), data }));
    } catch {
      // storage full / disabled — ignore
    }
  },
  clear() {
    try { sessionStorage.removeItem(KEY); } catch { /* ignore */ }
  },
};
